import { Component, Input } from '@angular/core';
import { HeaderComponent } from "../../shared/components/header/header.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-page',
  standalone: true,
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css',
  imports: [TranslateModule, HeaderComponent]
})
export class ErrorPageComponent {
  @Input() heading: string = 'web.errorCode1000GenericErrorHeader';
  @Input() message: string = 'web.errorCode1000GenericErrorBody';
  @Input() supportUrl: string = 'https://www.rejsebillet.dk';
  @Input() operationId?: string;

  onTryAgain(): void {
    window.location.reload();
  }

  onContactSupport(): void {
    window.open(this.supportUrl, '_blank');
  }
}
